export function getCurrencySymbol(currencyCode: string | null) {
  const lookup: { [key: string]: string } = {
    GBP: "£",
    EUR: "€",
  };
  if (currencyCode === null) return "£";
  if (currencyCode in lookup) return lookup[currencyCode];
  return "£";
}
